import { registerBlockType } from '@wordpress/blocks';
import Edit from './edit';
import Save from './save';

registerBlockType('rielstonenew/gen-stage-long', {
  edit: Edit,
  save: Save,
});
